import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, MapPin } from 'lucide-react';

const STATES = [
  { slug: 'jk', name: 'Jammu & Kashmir', districts: 20, homestays: '2,800+' },
  { slug: 'ladakh', name: 'Ladakh', districts: 2, homestays: '1,200+' },
  { slug: 'himachal', name: 'Himachal Pradesh', districts: 12, homestays: '3,790+' },
  { slug: 'uttarakhand', name: 'Uttarakhand', districts: 13, homestays: '3,550+' },
  { slug: 'sikkim', name: 'Sikkim', districts: 6, homestays: '1,900+' },
  { slug: 'westbengal', name: 'West Bengal', districts: 7, homestays: '1,215+' },
  { slug: 'assam', name: 'Assam', districts: 33, homestays: '1,580+' },
  { slug: 'meghalaya', name: 'Meghalaya', districts: 12, homestays: '1,260+' },
  { slug: 'tripura', name: 'Tripura', districts: 8, homestays: '910+' },
  { slug: 'mizoram', name: 'Mizoram', districts: 11, homestays: '990+' },
  { slug: 'manipur', name: 'Manipur', districts: 16, homestays: '1,220+' },
  { slug: 'nagaland', name: 'Nagaland', districts: 16, homestays: '1,190+' },
  { slug: 'arunachal', name: 'Arunachal Pradesh', districts: 28, homestays: '1,550+' },
];

export default function StateSelector({ current }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const currentState = STATES.find(s => s.slug === current);

  return (
    <div className="relative" ref={ref} data-testid="state-selector">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-white/50 hover:text-white/80 transition-colors text-xs tracking-[0.2em] uppercase"
      >
        <span className="hidden sm:inline">{currentState?.name || 'Select State'}</span>
        <span className="sm:hidden">States</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-2 w-64 bg-[#1a2430] border border-white/10 rounded-lg shadow-2xl overflow-hidden z-50"
          data-testid="state-selector-dropdown"
        >
          <div className="px-4 py-2.5 border-b border-white/5">
            <p className="text-white/30 text-[9px] tracking-[0.4em] uppercase">State Partnership Program</p>
          </div>
          {STATES.map(state => (
            <button
              key={state.slug}
              onClick={() => { navigate(`/states/${state.slug}`); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-white/5 transition-colors ${
                state.slug === current ? 'bg-white/5' : ''
              }`}
              data-testid={`state-option-${state.slug}`}
            >
              <MapPin className="w-3.5 h-3.5 text-white/30 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className={`text-sm ${state.slug === current ? 'text-white' : 'text-white/70'}`}>
                  {state.name}
                </p>
                <p className="text-white/25 text-[10px] mt-0.5">
                  {state.homestays} homestays &middot; {state.districts} districts
                </p>
              </div>
              {state.slug === current && (
                <div className="w-1.5 h-1.5 rounded-full bg-green-400 flex-shrink-0" />
              )}
            </button>
          ))}
          <div className="px-4 py-2.5 border-t border-white/5">
            <p className="text-white/15 text-[9px] italic">All 13 Himalayan states mapped</p>
          </div>
        </div>
      )}
    </div>
  );
}
